import { useState } from "react";
import apiMaestras from "../api/Maestras/api-maestras";
import { Entidad } from "../models/Maestras/maestras.model";

export const useGestionarEntidad = () => {
    const [cantidadPaginas, setCantidadPaginas] = useState(10);
    const cambiarCantidadPaginas = (e: any, value: any) => {
        setCantidadPaginas(value);
    };

    const [entidades, setEntidades] = useState<Entidad[]>([])
    const obtenerEntidad = async() => {
        try {
            const entidades = await apiMaestras.obtenerEntidades();
            setEntidades(entidades);
        } catch (error) {
            console.log(error)
        }
    }

    return {
        cantidadpaginas: cantidadPaginas,
        cambiarCantidadPaginas,
        obtenerEntidad,
        entidades
    } 
}
